
import React from "react";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import { CREATE_BOOKING_TYPE, MODALS } from "../../../config/params";
import { toastMessageActions } from "../../../state/request";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useDispatch } from "react-redux";
import { useModal } from "../../../context/ModalContext";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { useBookingAppointmentTypeStore } from "../../../hooks";
import PetSelection from "../../../components/PetSelection/PetSelection";

const PetSelectionContainer = () => {
  const dispatch = useDispatch();
  const { petList: petsActive } = usePetStore();
  const { selectedPets, setSelectedPets, reasonForVisit, setReasonForVisit } =
    useAppointmentStore();
  const { openModal } = useModal();
  const { bookingAppointmentType } = useBookingAppointmentTypeStore();

  const handleSelectPet = (pet: IPetItemResponse) => {
    if (selectedPets?.find((p: IPetItemResponse) => p.id === pet.id)) {
      setSelectedPets(
        selectedPets.filter((e: IPetItemResponse) => {
          return e.id !== pet.id;
        }),
      );
      const updatedReasonForVisits = { ...reasonForVisit };

      userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT_UNSELECT_PET, {
        referred_from: "left_nav",
        pet_name: pet.name,
        no_of_pets: selectedPets?.length - 1,
        appt_type:
                  bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ?
                    "drop_off" :
                    "in_room_visit",
      });

      delete updatedReasonForVisits[pet.id];
      setReasonForVisit(updatedReasonForVisits);
    } else if (selectedPets.length < 3) {
      userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT_SELECT_PET, {
        no_of_pets: 1 + selectedPets?.length,
        owner_type: petsActive?.length == 1 ? "single_pet" : "multipet",
        referred_from: "left_nav",
        pet_name: pet.name,
        appt_type:
                bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ?
                  "drop_off" :
                  "in_room_visit",
      });
      setSelectedPets([...selectedPets, pet]);
      setReasonForVisit({
        ...reasonForVisit,
        [pet.id]: { reasons: "", anything: " ", socReasons: [] },
      });
    } else if (selectedPets.length === 3) {
      dispatch(
        toastMessageActions.setGlobalAlert({
          severity: "error",
          message: "You can only book for three pets at a time.",
        }),
      );
    }
  };

  const handleClickAddAPet = () => {
    openModal(MODALS.ADD_A_PET);
  };

  return (
    <PetSelection
      petsActive={petsActive}
      selectedPets={selectedPets}
      visitType={"Doctor Visit"}
      handleSelectPet={handleSelectPet}
      handleClickAddAPet={handleClickAddAPet} />
  );
};

export default PetSelectionContainer;
